import { useMutation } from '@tanstack/react-query';

import { useSnackbar } from 'notistack';
import { EventReportClient, IncidentEventReportMutationRequest, ProblemDetails } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const eventReportClient = new EventReportClient(apiBaseUrl);

function useAddMultipleToIncident() {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<void, ProblemDetails, IncidentEventReportMutationRequest[]>({
    mutationKey: [queryKeys.EventReport.AddToIncident],
    mutationFn: (requests: IncidentEventReportMutationRequest[]) => eventReportClient.addMultipleToIncident(requests),
    onError: (error) => {
      const statusMessage = error.detail;

      enqueueSnackbar(statusMessage, { variant: 'error', persist: true });
    },
  });
}

export default useAddMultipleToIncident;
